import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common";

const formField = {
  category: {
    name: "category",
    label: "Category",
    type: "select",
    errorMsg: "Category is required.",
    required: true,
    maxLength: 50,
  },
  criteria: {
    name: "criteria",
    label: "Criteria",
    type: "select",
    errorMsg: "Criteria is required.",
    required: true,
    maxLength: 100,
  },
  invoiceNumber: {
    name: "invoiceNumber",
    label: "DocumentNumber",
    type: "text",
    errorMsg: "Document Number is required.",
    required: true,
    maxLength: 50,
  },
  invoiceDate: {
    name: "invoiceDate",
    label: "DocumentDate",
    type: "date",
    errorMsg: "Document Date is required.",
    required: true,
    maxLength: 50,
  },
  // containerNo: {
  //   name: "containerNo",
  //   label: "ContainerNo",
  //   type: "text",
  //   errorMsg: "Container No is required.",
  //   required: false,
  //   maxLength: 50,
  // },
  skuCode: {
    name: "skuCode",
    label: "SKUCode",
    type: "text",
    errorMsg: "SKUCode is required.",
    required: false,
    maxLength: 50,
  },
  actualQty: {
    name: "actualQty",
    label: "Actual Qty",
    type: "text",
    errorMsg: "Actual Qty is required.",
    required: false,
    maxLength: 50,
  },
  remark: {
    name: "remark",
    label: "Description",
    type: "text",
    errorMsg: "Description is required.",
    required: false,
    maxLength: 200,
  },
};

const { category,criteria,invoiceNumber,invoiceDate,skuCode,actualQty,remark,
 } = formField;

export const formRender = [[category],[criteria],[invoiceNumber],[invoiceDate],
[skuCode], [actualQty], [remark]];

export const initialValues = getInitialValues(formField);

export const billingServiceValidation = Yup.object().shape({
  [category.name]: Yup.string().nullable().max(category.maxLength).required(category.errorMsg),
  [criteria.name]: Yup.string().nullable().max(criteria.maxLength).required(criteria.errorMsg),
  [invoiceNumber.name]: Yup.string().nullable().max(invoiceNumber.maxLength).required(invoiceNumber.errorMsg),
  [invoiceDate.name]: Yup.string().nullable().max(20).required(invoiceDate.errorMsg),
  //[containerNo.name]: Yup.string().nullable().max(containerNo.maxLength).required(containerNo.errorMsg),
  // [skuCode.name]: Yup.string().nullable().max(skuCode.maxLength).required(skuCode.errorMsg),
  // [actualQty.name]: Yup.string().nullable().max(actualQty.maxLength).required(actualQty.errorMsg),
  // [remark.name]: Yup.string().nullable().max(20).required(remark.errorMsg),
});
